import React, { useEffect, useState, useCallback, useMemo } from "react";
import { getData, postData } from '../middleware/apiMiddleware';
import s from './ItemQuestions.module.css';
import { useNavigate } from "react-router-dom";
import { RedButton, GreenButton, BlueButton } from './MyButton';
import { Image, Form } from 'react-bootstrap';
import { SoundPlayer } from './Utilities/SoundPlayer.js';
import QuestionExplanation from '../components/QuestionExplanation';
import MyComponentLoading from '../components/Utilities/MyComponentLoading';
import {setGeneralStorage, getGeneralStorage} from '../middleware/dataStorage';



function createSeededRandom(seed) {
  // 使用固定常量确保良好的随机性
  const a = 1664525;
  const c = 1013904223;
  const m = 2 **32;
  let current = seed;

  return () => {
    current = (a * current + c) % m;
    return current / m; // 返回0-1之间的随机数
  };
}

// 使用种子随机化字符串
function shuffleStringWithSeed(str, seed) {
  if (str.length !== 4) {
    throw new Error("输入字符串必须是4个字符");
  }

  // 将字符串转换为数组便于操作
  const chars = str.split('');
  const random = createSeededRandom(seed);

  // Fisher-Yates 洗牌算法
  for (let i = chars.length - 1; i > 0; i--) {
    // 生成0到i之间的随机索引
    const j = Math.floor(random() * (i + 1));
    // 交换位置
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }

  return chars.join('');
}

function SeededShuffler(numberSeed) {
  const originalString = 'abcd';
  const timestamp = Date.now(); // 获取当前时间戳
  const combinedSeed = numberSeed + timestamp; // 组合种子（也可使用其他运算如乘法）
  
  // 生成随机结果
  const shuffled = shuffleStringWithSeed(originalString, combinedSeed);

  return shuffled
}



	function getPlaceholder(qcType) {
		let strRt = "paragraph\r\nmark\r\nquestion\r\nquestion hk\r\n";
		switch(qcType) {
			case 35:
				strRt = "07 (sound code)&#10;ck (answer)&#10;t&#10;p&#10;i";
				break;
			case 36:
				strRt = "kick (answer)&#10;hugs&#10;pick";
				break;
			case 37:
				strRt = "__d&#10;mad (answer)&#10;i&#10;l";
				break;
			case 30:
			case 31:
			case 47: //MC audio
			case 48: //MC image
			case 49: //MC meaning
			case 50: //MC meaning hk
				//strRt += "14567,14568|answer\r\n14555|choice1\r\nchoice2\r\nchoice3";
				strRt += "answer\r\nchoice1\r\nchoice2\r\nchoice3";
				break;
			case 38:
			case 39:
				strRt += "prefix\r\nanswer\r\nsuffix\r\n";
				break;
			case 56:
				strRt += "prefix\r\nanswer\r\nsuffix\r\n";
				break;
			case 44:
			case 45:
				strRt += "prefix\r\nanswer\r\nmodified answer\r\nsuffix";
				break;
			case 40:
			case 41:
				strRt += "prefix\r\nanswer\r\nsuffix\r\n123|choice1\r\n124|choice2\r\nchoice3";
				break;
			case 42:
			case 43:
				//strRt += "answer\r\nmodified answer";
				strRt += "answer\r\nmodified answer";
				break;
			case 46:
				strRt += "answer|answers\r\nai message";
				break;
			case 57:
				strRt += "answer|answers\r\nai message";
				break;
			case 51: //separator
				strRt = "paragraph\r\nmark\r\ntitle\r\ntitle hk\r\nquestion\r\nquestion hk\r\noption|option|option...";
				break;
			case 52: //true false
				strRt += "TRUE,FALSE";
				break;
			case 53: //true false (multi answer)
				strRt += "TRUE,FALSE";
				break;
			case 54: //true false NA
				strRt += "TRUE,FALSE,NA\r\n";
				break;
			case 55: //matching
				strRt += "answer\r\n";
				break;
		}
		strRt += "\r\nexplanation\r\nexplanation hk";
		
		return strRt;
	}


export default function ItemQuestions(prop) {	
	const navigate = useNavigate();
	
	const { itemId, wordId, itemType = -1 } = prop;
	
	const [fetchCompleted, setFetchCompleted] = useState(false);
	const [qtns, setQtns] = useState([]);
	const [defLP, setDefLP] = useState([72,73,74,75,81,82,83,84,85,86,87,88].includes(itemType) ? "wks" : "vocab");
	const [qtnFormats, setQtnFormats] = useState([]);
	const [qtnTypes, setQtnTypes] = useState([]);
	const [imagesPoolData, setImagesPoolData] = useState([]);
	// 添加摘要显示模式的状态控制
	const [showSummary, setShowSummary] = useState(getGeneralStorage('showSummary') ?? false);

	const [genExplanationAll, setGenExplanationAll] = useState(false);
	const [genExplanationIncompleted, setGenExplanationIncompleted] = useState(false);

	const callChildGenExplanationAllLogic = useCallback(() => {
		// 1. Trigger child logic
		setGenExplanationAll(true);

		// 2. Auto-reset trigger after a short delay (give child time to react)
		const timer = setTimeout(() => {
			setGenExplanationAll(false);
		}, 0); // 0ms delay: runs after current render cycle (child's useEffect executes first)

		// Cleanup timer if component unmounts before reset
		return () => clearTimeout(timer);
	}, []);

	const callChildGenExplanationIncompletedLogic = useCallback(() => {
		// 1. Trigger child logic
		setGenExplanationIncompleted(true);

		// 2. Auto-reset trigger after a short delay (give child time to react)
		const timer = setTimeout(() => {
			setGenExplanationIncompleted(false);
		}, 0); // 0ms delay: runs after current render cycle (child's useEffect executes first)

		// Cleanup timer if component unmounts before reset
		return () => clearTimeout(timer);
	}, []);



const QuestionTextArea = ({ index, qcType, inputFeedback }) => {
  const [istr, setIstr] = useState("");

  const feedback = (e) => {
    setIstr(e.target.value);
  };

  const loadData = () => {
    const updatedQtns = [...qtns];
    console.log(istr);
    setIstr("");
    const strArray = istr.split(/\r?\n/);

    // ✨ Reusable helper: Update field + call updateQuestionField (only if value is not null/undefined)
    const updateField = async (fieldKey, fieldValue) => {
		if (fieldKey == 'paragraph') {
        	updatedQtns[index]['paragraph'] = fieldValue ? fieldValue.split(',').map(id => id.trim()) : [];
        	updatedQtns[index]['paragraphStr'] = fieldValue;
		
			const filteredParagraph = updatedQtns[index]['paragraph'];
			await postData("questionApi/updateParagraph", { qtnId: qtns[index].id, paragraph: filteredParagraph }, navigate);
		} else if (fieldValue !== null && fieldValue !== undefined) {
        updatedQtns[index][fieldKey] = fieldValue;
        updateQuestionField(qtns[index].id, fieldValue, fieldKey, qcType);
      }
    };

    // ✨ Batch update helper (for multiple fields)
    const updateFields = (fieldMap) => {
      Object.entries(fieldMap).forEach(([key, value]) => updateField(key, value));
    };

    // --------------------------
    // Handle different qcType cases
    // --------------------------
    if ([46].includes(qcType)) {
      const fields = {
		paragraph: strArray[0],
		mark: strArray[1],
        question: strArray[2],
        questionHk: strArray[3],
        answer: strArray[4],
        aiMsg: strArray[5],
        explanation: strArray[6],
        explanationHk: strArray[7],
      };
      updateFields(fields);

    } else if ([57].includes(qcType)) {
      const fields = {
		paragraph: strArray[0],
		mark: strArray[1],
        question: strArray[2],
        answer: strArray[3],
        aiMsg: strArray[4],
        explanation: strArray[5],
        explanationHk: strArray[6],
      };
      updateFields(fields);

    } else if ([42, 43].includes(qcType)) {
      const fields = {
		paragraph: strArray[0],
		mark: strArray[1],
        question: strArray[2],
        questionHk: strArray[3],
        answer: strArray[4],
        modifiedAnswer: strArray[5],
        explanation: strArray[6],
        explanationHk: strArray[7],
      };
      updateFields(fields);

    } else if ([38, 39, 56].includes(qcType)) {
      const fields = {
		paragraph: strArray[0],
		mark: strArray[1],
        question: strArray[2],
        questionHk: strArray[3],
        prefix: strArray[4],
        answer: strArray[5],
        suffix: strArray[6],
        aiContent: strArray[7],
        explanation: strArray[8],
        explanationHk: strArray[9],
      };
      updateFields(fields);

    } else if ([52, 53, 54, 55].includes(qcType)) {
      const fields = {
		paragraph: strArray[0],
		mark: strArray[1],
        question: strArray[2],
        questionHk: strArray[3],
        answer: strArray[4],
        explanation: strArray[5],
        explanationHk: strArray[6],
      };
      updateFields(fields);

    } else if ([40, 41].includes(qcType)) {
      const fields = {
		paragraph: strArray[0],
		mark: strArray[1],
        question: strArray[2],
        questionHk: strArray[3],
        prefix: strArray[4],
        answer: strArray[5],
        choice1: strArray[6],
        choice2: strArray[7],
        choice3: strArray[8],
        suffix: strArray[9],
        aiContent: strArray[10],
        explanation: strArray[11],
        explanationHk: strArray[12],
      };
      updateFields(fields);

    } else if ([44, 45].includes(qcType)) {
      const fields = {
		paragraph: strArray[0],
		mark: strArray[1],
        question: strArray[2],
        questionHk: strArray[3],
        prefix: strArray[4],
        answer: strArray[5],
        modifiedAnswer: strArray[6],
        suffix: strArray[7], // Keep original index (skips 5/6)
        aiContent: strArray[8],
        explanation: strArray[9],
        explanationHk: strArray[10],
      };
      updateFields(fields);

    } else if ([30, 31, 47, 48, 49, 50].includes(qcType)) {
      const fields = {
		paragraph: strArray[0],
		mark: strArray[1],
        question: strArray[2],
        questionHk: strArray[3],
        answer: strArray[4],
        choice1: strArray[5],
        choice2: strArray[6],
        choice3: strArray[7],
        explanation: strArray[8],
        explanationHk: strArray[9],
      };
      updateFields(fields);

    } else if ([51].includes(qcType)) {
      const fields = {
		paragraph: strArray[0],
		mark: strArray[1],
        title: strArray[2],
        titleHk: strArray[3],
        question: strArray[4],
        questionHk: strArray[5],
        optionLabel: strArray[6],
        options: strArray?.[7] ? strArray[7].split('|') : [],
        explanation: strArray[8],
        explanationHk: strArray[9],
      };
      updateFields(fields);
    }

    setQtns(updatedQtns);
  };

  return (
    <div>
      <textarea
        className={s.textAreaAuto}
        value={istr}
        rows={10}
        wrap="off"
        placeholder={getPlaceholder(qcType)}
        onChange={feedback}
      />
      <div style={{ display: "flex", gap: "10px" }}>
        <BlueButton isEnabled={true} clickedAction={() => loadData()} bText={"load =>"} />
        {/*<BlueButton isEnabled={true} clickedAction={() => loadData()} bText={"unload <="} />*/}
      </div>
    </div>
  );
};
	/*
	const QuestionTextArea = ({index, qcType, inputFeedback}) => {
		
		const [istr, setIstr] = useState("");
		const feedback = (e) => {
			setIstr(e.target.value);
		}

		const loadData = () => {
			const updatedQtns = [...qtns];
			console.log(istr);
			setIstr("");
			const strArray = istr.split(/\r?\n/);
			if ([46].includes(qcType)) {

				let question = strArray[0];
				let questionHk = strArray[1];
				let answer = strArray[2];
				let aiMsg = strArray[3];
				let explanation = strArray[4];
				let explanationHk = strArray[5];

				updatedQtns[index]["question"] = question;
				updatedQtns[index]["questionHk"] = questionHk;
				updatedQtns[index]["answer"] = answer;
				updatedQtns[index]["aiMsg"] = aiMsg;
				updatedQtns[index]["explanation"] = explanation;
				updatedQtns[index]["explanationHk"] = explanationHk;

				updateQuestionField(qtns[index].id, question, "question", qcType);
				updateQuestionField(qtns[index].id, questionHk, "questionHk", qcType);
				updateQuestionField(qtns[index].id, answer, "answer", qcType);
				updateQuestionField(qtns[index].id, aiMsg, "aiMsg", qcType);
				updateQuestionField(qtns[index].id, explanation, "explanation", qcType);
				updateQuestionField(qtns[index].id, explanationHk, "explanationHk", qcType);
			} else if ([57].includes(qcType)) {

				let question = strArray[0];
				let answer = strArray[1];
				let aiMsg = strArray[2];
				let explanation = strArray[3];
				let explanationHk = strArray[4];

				updatedQtns[index]["question"] = question;
				updatedQtns[index]["answer"] = answer;
				updatedQtns[index]["aiMsg"] = aiMsg;
				updatedQtns[index]["explanation"] = explanation;
				updatedQtns[index]["explanationHk"] = explanationHk;

			} else if ([42,43].includes(qcType)) {
				let question = strArray[0];
				let questionHk = strArray[1];
				let answer = strArray[2];
				let modifiedAnswer = strArray[3];
				let explanation = strArray[4];
				let explanationHk = strArray[5];

				updatedQtns[index]["question"] = question;
				updatedQtns[index]["questionHk"] = questionHk;
				updatedQtns[index]["answer"] = answer;
				updatedQtns[index]["modifiedAnswer"] = modifiedAnswer;
				updatedQtns[index]["explanation"] = explanation;
				updatedQtns[index]["explanationHk"] = explanationHk;
			} else if ([38,39,56].includes(qcType)) {
				let question = strArray[0];
				let questionHk = strArray[1];
				let prefix = strArray[2];
				let answer = strArray[3];
				let suffix = strArray[4];
				let aiContent = strArray[5];
				let explanation = strArray[6];
				let explanationHk = strArray[7];

				updatedQtns[index]["question"] = question;
				updatedQtns[index]["questionHk"] = questionHk;
				updatedQtns[index]["prefix"] = prefix;
				updatedQtns[index]["answer"] = answer;
				updatedQtns[index]["suffix"] = suffix;
				updatedQtns[index]["aiContent"] = aiContent;
				updatedQtns[index]["explanation"] = explanation;
				updatedQtns[index]["explanationHk"] = explanationHk;
			} else if ([52,53,54, 55].includes(qcType)) {
				let question = strArray[0];
				let questionHk = strArray[1];
				let answer = strArray[2];
				let explanation = strArray[3];
				let explanationHk = strArray[4];

				updatedQtns[index]["question"] = question;
				updatedQtns[index]["questionHk"] = questionHk;
				updatedQtns[index]["answer"] = answer;
				updatedQtns[index]["explanation"] = explanation;
				updatedQtns[index]["explanationHk"] = explanationHk;
			}  else if ([40,41].includes(qcType)) {
				let question = strArray[0];
				let questionHk = strArray[1];
				let prefix = strArray[2];
				let answer = strArray[3];
				let choice1 = strArray[4];
				let choice2 = strArray[5];
				let choice3 = strArray[6];
				let suffix = strArray[7];
				let aiContent = strArray[8];
				let explanation = strArray[9];
				let explanationHk = strArray[10];

				updatedQtns[index]["question"] = question;
				updatedQtns[index]["questionHk"] = questionHk;
				updatedQtns[index]["answer"] = answer;
				updatedQtns[index]["prefix"] = prefix;
				updatedQtns[index]["suffix"] = suffix;
				updatedQtns[index]["choice1"] = choice1;
				updatedQtns[index]["choice2"] = choice2;
				updatedQtns[index]["choice3"] = choice3;
				updatedQtns[index]["aiContent"] = aiContent;
				updatedQtns[index]["explanation"] = explanation;
				updatedQtns[index]["explanationHk"] = explanationHk;
			}  else if ([44,45].includes(qcType)) {
				let question = strArray[0];
				let questionHk = strArray[1];
				let prefix = strArray[2];
				let answer = strArray[3];
				let modifiedAnswer = strArray[4];
				let suffix = strArray[7];
				let aiContent = strArray[8];
				let explanation = strArray[9];
				let explanationHk = strArray[10];

				updatedQtns[index]["question"] = question;
				updatedQtns[index]["questionHk"] = questionHk;
				updatedQtns[index]["answer"] = answer;
				updatedQtns[index]["prefix"] = prefix;
				updatedQtns[index]["suffix"] = suffix;
				updatedQtns[index]["modifiedAnswer"] = modifiedAnswer;
				updatedQtns[index]["aiContent"] = aiContent;
				updatedQtns[index]["explanation"] = explanation;
				updatedQtns[index]["explanationHk"] = explanationHk;
			}  else if ([30,31,47,48,49,50].includes(qcType)) {
				let question = strArray[0];
				let questionHk = strArray[1];
				let answer = strArray[2];
				let choice1 = strArray[3];
				let choice2 = strArray[4];
				let choice3 = strArray[5];
				let explanation = strArray[6];
				let explanationHk = strArray[7];

				updatedQtns[index]["question"] = question;
				updatedQtns[index]["questionHk"] = questionHk;
				updatedQtns[index]["answer"] = answer;
				updatedQtns[index]["choice1"] = choice1;
				updatedQtns[index]["choice2"] = choice2;
				updatedQtns[index]["choice3"] = choice3;
				updatedQtns[index]["explanation"] = explanation;
				updatedQtns[index]["explanationHk"] = explanationHk;

				updateQuestionField(qtns[index].id, question, "question", qcType);
				updateQuestionField(qtns[index].id, questionHk, "questionHk", qcType);
				updateQuestionField(qtns[index].id, answer, "answer", qcType);
				updateQuestionField(qtns[index].id, choice1, "choice1", qcType);
				updateQuestionField(qtns[index].id, choice2, "choice2", qcType);
				updateQuestionField(qtns[index].id, choice3, "choice3", qcType);
				updateQuestionField(qtns[index].id, explanation, "explanation", qcType);
				updateQuestionField(qtns[index].id, explanationHk, "explanationHk", qcType);
			}  else if ([51].includes(qcType)) {
				let title = strArray[0];
				let titleHk = strArray[1];
				let question = strArray[2];
				let questionHk = strArray[3];
				let optionLabel = strArray[4];
				let options = strArray?.[5] ? strArray[5].split('|') : [];
				let explanation = strArray[6];
				let explanationHk = strArray[7];

				updatedQtns[index]["title"] = title;
				updatedQtns[index]["titleHk"] = titleHk;
				updatedQtns[index]["question"] = question;
				updatedQtns[index]["questionHk"] = questionHk;
				updatedQtns[index]["optionLabel"] = optionLabel;
				updatedQtns[index]["options"] = options;
				updatedQtns[index]["explanation"] = explanation;
				updatedQtns[index]["explanationHk"] = explanationHk;
			}
			setQtns(updatedQtns);
		}

		return (<div>
			<textarea
				className={s.textAreaAuto}
				value={istr}
				rows={10}
				wrap="off"
				placeholder={getPlaceholder(qcType)}
				onChange={feedback}
			/>
			<div style={{ display: "flex", gap: "10px"}}>
				<BlueButton isEnabled={true} clickedAction={() => loadData()} bText={"load =>"} />
				
			</div>
		</div>)

		//return (<div>{JSON.stringify(input, null, 2)}</div>)
	}*/

	// 3. 顶层定义onChange处理函数（用useCallback，接收indexQ和config参数）
	const handleTextAreaChange = useCallback((e, indexQ, config) => {
		const str = e.target.value;
		const strArray = str.split(/\r?\n/);
		
		// 不可变更新状态
		setQtns(prevQtns => {
			const newQtns = [...prevQtns];
			const updatedQuestion = { ...newQtns[indexQ], input: str };
			const processedQuestion = config.process(strArray, updatedQuestion);
			
			// 执行choice调用
			config.choiceCalls.forEach(call => call(indexQ, strArray));
			
			newQtns[indexQ] = processedQuestion;
			return newQtns;
		});
	}, []);
	// Generic handler for updating question fields
	const updateQuestionField = async (qtnId, value, field, qcType) => {
		const endpoints = {
			mark: "questionApi/updateMark",
			prefix: "questionApi/prefixUpdate",
			answer: "questionApi/answerUpdate",
			choice1: "questionApi/choice1Update",
			choice2: "questionApi/choice2Update",
			choice3: "questionApi/choice3Update",
			suffix: "questionApi/suffixUpdate",
			optionLabel: "questionApi/optionLabelUpdate",
			explanation: "questionApi/explanationUpdate",
			explanationHk: "questionApi/explanationHkUpdate",
			modifiedAnswer: "questionApi/modifiedAnswerUpdate",
			aiMsg: "questionApi/aiMsgUpdate",
			aiContent: "questionApi/aiContentUpdate",
			question: "questionApi/newQuestionUpdate",
			title: "questionApi/titleUpdate",
			titleHk: "questionApi/titleHkUpdate",
			questionHk: "questionApi/newQuestionHkUpdate",
			answerLpIds: "questionApi/updateLearningPoint" // Added endpoint for weakness IDs
		};

		if (!endpoints[field]) return;
		await postData(endpoints[field], { qtnId, [field]: value, qcType }, navigate);
	};

	// Helper to create input change handlers
	const createInputHandler = (indexQ, field, additionalAction) => {
		return {
			onChange: (e) => {
				const updatedQtns = [...qtns];
				updatedQtns[indexQ][field] = e.target.value;
				updatedQtns[indexQ].inputStr = (mergeFieldToInput(updatedQtns[indexQ])).inputStr;

				setQtns(updatedQtns);
			},
			onBlur: (e) => {
				const value = e.target.value.trim();
				const updatedQtns = [...qtns];
				updatedQtns[indexQ][field] = value;
				updatedQtns[indexQ].inputStr = (mergeFieldToInput(updatedQtns[indexQ])).inputStr;
				setQtns(updatedQtns);
				
				if (qtns[indexQ].id) {
					updateQuestionField(qtns[indexQ].id, value, field, qtns[indexQ].qcType);
				}
				additionalAction?.(value, indexQ);
			}
		};
	};

	const createQtn = async (qcType) => {
		const params = { itemId, qcType, ordering: qtns.length };
		const res = await postData("questionApi/emptyCreate", params, navigate);
		const newQtn = { 
			input: '\n\n\n\n\n\n\n\n\n\n\n',
			id: res.data, 
			qcType, 
			soundText: '',
			soundMp3: null, 
			mark: '1', 
			title: '', 
			answer: '', 
			choice1: '', 
			choice2: '', 
			choice3: '', 
			aiMsg: '',
			optionsOrder: SeededShuffler(res.data),
			// Initialize paragraph fields
			paragraph: [],
			paragraphStr: "",
			// Initialize weakness fields
			answerLpIds: [],
			answerLpIdsStr: ""
		};
		setQtns(prev => [...prev, newQtn]);
	};
	
	const extractNumbers = (str) => {
		const regex = /^\[(\d+(?:,\s*\d+)*)\]/;
		const matches = str.match(regex);
		return matches?.[1] ? matches[1].split(",").map(Number) : [];
	};

	const translateHk = async (sentence) => {
		const res = await postData("utility/translateSentence", { sentence }, navigate); 
		return res.data;
	};
	
	const translateHkEscapeWord = async (sentence) => {
		const res = await postData("utility/translateSentenceEscapeWord", { sentence }, navigate); 
		return res.data;
	};

	const removePrefixAndSuffix = (str) => {
		const prefixRegex = /^\[\d+(?:,\s*\d+)*\]/;
		const suffixRegex = /\(\d+ mark\)$/;
		return str.replace(prefixRegex, '').replace(suffixRegex, '').trim();
	};
		
	const extraQuestion = (str) => ({
		paragraph: extractNumbers(str),
		question: removePrefixAndSuffix(str)	
	});
		
	const extractTitle = (str) => ({
		paragraph: extractNumbers(str),
		title: removePrefixAndSuffix(str)	
	});
	
	const removeMCPrefix = (str) => str.replace(/^(\w[.)/:]\s*)/i, '');
		
	// Item questions fetching
	const fetchItemQtns = () => {
		getQuestionFormatAndTypeById();
		getData(`item/listItemQtns?itemId=${itemId}`, navigate)
			.then(res => {
				const questions = res.data.map(q => {
					// Process paragraph data
					const paragraph = q.json?.paragraph || [];
					const cleanedParagraph = paragraph.filter(p => p !== '');
					const paragraphStr = cleanedParagraph.join(',');
					
					// Process weakness/answerLpIds data
					const answerLpIds = q.answerLpIds || [];
					const answerLpIdsStr = answerLpIds.map(item => item.id).join(',');
					
					const mergedQ = mergeFieldToInput(q);
					return { 
   						...mergedQ,
						paragraph: cleanedParagraph,
						paragraphStr: paragraphStr,
						answerLpIds: answerLpIds,
						answerLpIdsStr: answerLpIdsStr
					};
				});
				setQtns(questions);
				setFetchCompleted(true);
			});
	};

	const updateImageToQtn = async (indexQ, ip) => {
		const updatedQtns = [...qtns];
		updatedQtns[indexQ].imagePath = ip;
		setQtns(updatedQtns);
		await postData("questionApi/updateImage", { itemId, imagePath: ip, qtnId: qtns[indexQ].id }, navigate);
	};	
	
	const getQuestionFormatAndTypeById = () => {
		getData(`questionApi/getQuestionFormatAndTypeById?id=${itemId}`, navigate)
			.then(res => {
				setQtnFormats(res.data.formats);
				setQtnTypes(res.data.types);
			});	
	};
	
	// Word questions fetching
	const fetchWordQtns = () => {		
		getData(`wordApi/getQtnsByWordId?wordId=${wordId}`, navigate)
			.then(res => {
				const questions = res.data.map(q => {
					// Process paragraph data
					const paragraph = q.json?.paragraph || [];
					const cleanedParagraph = paragraph.filter(p => p.trim() !== '');
					const paragraphStr = cleanedParagraph.join(',');
					
					// Process weakness/answerLpIds data
					const answerLpIds = q.answerLpIds || [];
					const answerLpIdsStr = answerLpIds.map(item => item.id).join(',');
					
					return { 
						...q, 
						input: mergeFieldToInput(q),
						paragraph: cleanedParagraph,
						paragraphStr: paragraphStr,
						answerLpIds: answerLpIds,
						answerLpIdsStr: answerLpIdsStr
					};
				});
				setQtns(questions);
			});
	};
	
	const createMCQuestionByWordId = async () => {
		await postData("wordApi/createMCMeaning", { wordId }, navigate);
		await postData("wordApi/createMCMeaningHk", { wordId }, navigate);
		fetchWordQtns();
	};
	
	const createOrUpdateQtn = async (indexQ) => {
		// Currently disabled in original code - kept as is
		/*
		const obj = { ...qtns[indexQ], ordering: indexQ };
		if (itemId) obj.itemId = itemId;
		if (wordId) obj.wordId = wordId;
		
		await postData("questionApi/updateOrCreateQuestion", obj, navigate)
			.then(res => {
				const updatedQtns = [...qtns];
				updatedQtns[indexQ].id = res.data;
				setQtns(updatedQtns);
			});
		*/
	};
	
	const updateOptionsOrder = async (qtnId, optionsOrder) => {
		await postData("questionApi/updateOptionsOrder", { id: qtnId, optionsOrder }, navigate);
	};

	const updateParagraph = async (qtnId, paragraph) => {
		const filteredParagraph = paragraph.filter(id => id.trim() !== "");
		await postData("questionApi/updateParagraph", { qtnId, paragraph: filteredParagraph }, navigate);
	};
	
	const qcTypeUpdate = async (qtnId, qcType) => {
		await postData("questionApi/qcTypeUpdate", { qtnId, qcType }, navigate);
	};
		
	const updateOptions = async (qtnId, options) => {
		await postData("questionApi/updateOptions", { qtnId, options }, navigate);
	};
	
	const removeImageInQtn = async (qtnId) => {
		await postData("questionApi/removeImageInQtn", { itemId, qtnId }, navigate);
	};
	
	const getItemImages = () => {
		getData(`item/listItemImagePool?itemId=${itemId}`, navigate)
			.then(res => setImagesPoolData(res.data));	
	};
	
	/*
	const inputFeedback = (indexQ, inputStr) => {
		const updatedQtns = [...qtns];
		updatedQtns[indexQ].inputStr = inputStr;

		let str = inputStr;
		let strArray = str.split(/\r?\n/);
		console.log(strArray);
		if (updatedQtns[indexQ].qcType === 46) {
			updatedQtns[indexQ].question = strArray[1];
			updatedQtns[indexQ].questionHk = strArray[2];
			processMCChoiceChange(indexQ, strArray[3], "answer", "answerLpIds");
			updatedQtns[indexQ].aiMsg = strArray[4];
			updatedQtns[indexQ].explanation = strArray[5];
			updatedQtns[indexQ].explanationHk = strArray[6];
		}
		setQtns(updatedQtns);

	}*/


	const loadCoreWks = async (indexQ, rWksId) => {
		const updatedQtns = [...qtns];
		let isBreak = false;
		
		for (const a of updatedQtns[indexQ].answerLpIds) {
			a.name = await checkWksId(a.id);
			if (a.id === rWksId) isBreak = true;
		}
		
		if (isBreak) {
			setQtns(updatedQtns);
			return;
		}
		
		const tmpName = await checkWksId(rWksId);
		updatedQtns[indexQ].answerLpIds.push({ id: rWksId, name: tmpName });
		updatedQtns[indexQ].answerLpIdsStr = updatedQtns[indexQ].answerLpIds.map(item => item.id).join(',');
		//updatedQtns[indexQ].input = mergeFieldToInput(updatedQtns[indexQ]);
		updatedQtns[indexQ].inputStr = (mergeFieldToInput(updatedQtns[indexQ])).inputStr;
		setQtns(updatedQtns);
	};
	
	const mergeFieldToInput = (q) => {
		// Initialize missing fields
		const safeQ = {
			explanation: "", explanationHk: "", aiContent: "", title: "", titleHk: "",
			answer: "", choice1: "", choice2: "", choice3: "", prefix: "", suffix: "",
			modifiedAnswer: "", optionLabel: "", mark: "1", json: {}, options: [],
			answerLpIds: [], answerLpIdsStr: "",
			choice1LpIds: [], choice2LpIds: [], choice3LpIds: [],
			paragraph: [], paragraphStr: "",
			...q
		};

		if (!q.optionsOrder) {
			q.optionsOrder = SeededShuffler(q.id)
			updateOptionsOrder(q.id, q.optionsOrder);
		}

		// Update weakness IDs string from array
		safeQ.answerLpIdsStr = safeQ.answerLpIds.map(item => item.id).join(',');
		safeQ.answerLpIdsStrName = safeQ.answerLpIds.map(item => item.name).join(',');
		
		// Update paragraph string from array
		safeQ.paragraphStr = safeQ.json?.paragraph ? safeQ.json.paragraph.join(',') : "";
		safeQ.paragraph = safeQ.json?.paragraph ? safeQ.json.paragraph : [];
		
		safeQ.optionsStr = safeQ.options.join('|');
		
		let qStr = "";
		if (safeQ.paragraph.length>0) {
			qStr = safeQ.paragraph.join(',');
		}
		qStr += "\n" + q.mark + "\n";
		switch(safeQ.qcType) {
				case 35:
					qStr += safeQ.soundCode + "\n" + safeQ.answer  + "\n" + safeQ.choice1 + "\n" + safeQ.choice2 + "\n" + safeQ.choice3;
					break;
				case 36:
					qStr += safeQ.answer  + "\n" + safeQ.choice1 + "\n" + safeQ.choice2 + "\n" + safeQ.choice3;
					break;
				case 37:
					qStr += safeQ.display + "\n" + safeQ.answer  + "\n" + safeQ.choice1 + "\n" + safeQ.choice2 + "\n" + safeQ.choice3;
					break;					
				case 30: //MC
				case 31: 
				case 47: //MC audio
				case 48: //MC image
				case 49: //MC meaning
				case 50: //MC meaning hk
					qStr += safeQ.question + "\n" + safeQ.questionHk + "\n" + 
						((safeQ.answerLpIds.length > 0) ? safeQ.answerLpIds.map(o => o.id).join(',') + "|" : "") + safeQ.answer + "\n" +
						((safeQ.choice1LpIds.length > 0) ? safeQ.choice1LpIds.map(o => o.id).join(',') + "|" : "") + safeQ.choice1 + "\n" +
						((safeQ.choice2LpIds.length > 0) ? safeQ.choice2LpIds.map(o => o.id).join(',') + "|" : "") + safeQ.choice2 + "\n" +
						((safeQ.choice3LpIds.length > 0) ? safeQ.choice3LpIds.map(o => o.id).join(',') + "|" : "") + safeQ.choice3
					break;
				case 56: //Drag-fill-in
					qStr += safeQ.question + "\n" + safeQ.questionHk + "\n" + 
						safeQ.prefix + "\n" +
						((safeQ.answerLpIds.length > 0) ? safeQ.answerLpIds.map(o => o.id).join(',') + "|" : "") + safeQ.answer + "\n" +
						 safeQ.suffix + "\n" + 
						 safeQ.aiContent
					break;
				case 38: //Fill-in-the-blank
				case 39: 
					qStr += safeQ.question + "\n" + safeQ.questionHk + "\n" + 
						safeQ.prefix + "\n" +
						((safeQ.answerLpIds.length > 0) ? safeQ.answerLpIds.map(o => o.id).join(',') + "|" : "") + safeQ.answer + "\n" +
						 safeQ.suffix + "\n" + 
						 safeQ.aiContent
					break;
				case 44: //Paragraph(Fill-in)
				case 45: 
					if (!safeQ.modifiedAnswer) {
						safeQ.modifiedAnswer = "";
					}
				
					qStr += safeQ.question + "\n" + safeQ.questionHk + "\n" + 
						safeQ.prefix + "\n" +
						((safeQ.answerLpIds.length > 0) ? safeQ.answerLpIds.map(o => o.id).join(',') + "|" : "") + safeQ.answer + "\n" +
						 safeQ.modifiedAnswer + "\n" +
						 safeQ.suffix + "\n" + 
						 safeQ.aiContent
					break;
				case 40: //dropdown box
				case 41: 
					qStr += safeQ.question + "\n" + safeQ.questionHk + "\n" + 
						safeQ.prefix + "\n" +
						((safeQ.answerLpIds.length > 0) ? safeQ.answerLpIds.map(o => o.id).join(',') + "|" : "") + safeQ.answer + "\n" +
						 safeQ.suffix + "\n" + 
						 safeQ.aiContent + "\n" + 
						((safeQ.choice1LpIds.length > 0) ? safeQ.choice1LpIds.map(o => o.id).join(',') + "|" : "") + safeQ.choice1 + "\n" +
						((safeQ.choice2LpIds.length > 0) ? safeQ.choice2LpIds.map(o => o.id).join(',') + "|" : "") + safeQ.choice2 + "\n" +
						((safeQ.choice3LpIds.length > 0) ? safeQ.choice3LpIds.map(o => o.id).join(',') + "|" : "") + safeQ.choice3
					break;
				case 42:
				case 43: //"Paragraph";
					if (!safeQ.modifiedAnswer) {
						safeQ.modifiedAnswer = "";
					}
					qStr += safeQ.question + "\n" + safeQ.questionHk + "\n" + 
						((safeQ.answerLpIds.length > 0) ? safeQ.answerLpIds.map(o => o.id).join(',') + "|" : "") + safeQ.answer + "\n" +
						 safeQ.modifiedAnswer
					break;
				case 46: 
					if (!safeQ.aiMsg) {
						safeQ.aiMsg = "";
					}
					qStr += safeQ.question + "\n" + safeQ.questionHk + "\n" + 
						 ((safeQ.answerLpIds.length > 0) ? safeQ.answerLpIds.map(o => o.id).join(',') + "|" : "") + safeQ.answer + "\n" +
						 safeQ.aiMsg
					break;
				case 57: 
					if (!safeQ.aiMsg) {
						safeQ.aiMsg = "";
					}
					qStr += safeQ.question + "\n" +  
						 ((safeQ.answerLpIds.length > 0) ? safeQ.answerLpIds.map(o => o.id).join(',') + "|" : "") + safeQ.answer + "\n" +
						 safeQ.aiMsg
					break;
				case 51:  //separator
					qStr += safeQ.title + "\n" + safeQ.titleHk + "\n" +
						 safeQ.question + "\n" + safeQ.questionHk + "\n" + safeQ.optionLabel + "\n" + safeQ.options.join('|')
					 break;
				case 52: // true false
				case 53: // true false (multi answer)
				case 54: // true false NA
				case 55: // matching
					qStr += safeQ.question + "\n"+ safeQ.questionHk + "\n" + 
						 safeQ.answer
					break;
			}
			

		safeQ.inputStr = qStr
		return safeQ
	};
	
	const vocabLabel = (qcType) => {
		switch(qcType) {
			case 30: case 38: case 40: case 42: case 44: case 46: 
			case 52: case 53: case 54: case 55: case 56: case 57: 
				return "wks";
			default: return "vocab";
		}
	};
	
	const qcTypeLabel = (qcType) => {
		const labels = {
			30: "MC +wks", 31: "MC +vocab",
			47: "MC audio", 48: "MC image", 49: "MC meaning", 50: "MC meaning HK",
			51: "Separator", 56: "Drag-fill-in",
			38: "Fill-in-the-blank +wks", 39: "Fill-in-the-blank +vocab",
			40: "Dropdown box +wks", 41: "Dropdown box +vocab",
			42: "Paragraph +wks", 43: "Paragraph +vocab",
			44: "Paragraph(Fill-in) +wks", 45: "Paragraph(Fill-in) +vocab",
			46: "Open", 57: "Sentence replacement",
			52: "True false", 53: "True false(Multi-answer)", 54: "True false NG", 55: "Matching"
		};
		return labels[qcType] || "?";
	};
	
	const StrBrChange = ({ str }) => str ? (
		<div>
			{str.split("\\n").map((item, idx) => (
				<span key={idx}>{item}<br/></span>
			))}
		</div>
	) : <span></span>;
	
	const deleteQtn = async (id, indexQ) => {
		if (id) {
			const obj = { id };
			if (itemId) obj.itemId = itemId;
			else if (wordId) obj.wordId = wordId;
			await postData("questionApi/removeQtnFromList", obj, navigate);
		}

		const updatedQtns = [...qtns];
		updatedQtns.splice(indexQ, 1);
		setQtns(updatedQtns);
	};
	
	const checkWksId = async (id) => {
		try {
			const res = await getData(`weaknessApi/getById?id=${id}`, navigate);
			return res?.data?.name || "Name not available";
		} catch (error) {
			console.error(`Error fetching weakness ${id}:`, error);
			return "Error";
		}
	};
	
	const handleClick = (id) => {
		const element = document.getElementById(id);
		if (element) element.scrollIntoView({ behavior: 'smooth' });
	};
	
	useEffect(() => {
		if (itemId) fetchItemQtns();
		else if (wordId) fetchWordQtns();
	}, [itemId, wordId]);
	
	const changeSeparatorType = async (indexQ) => {
		const qtnId = qtns[indexQ].id;
		const newType = qtns[indexQ].separatorType === 'default' ? 'immutable' : 'default';
		await postData("questionApi/updateSeparatorType", { qtnId, separatorType: newType }, navigate);
		
		const updatedQtns = [...qtns];
		updatedQtns[indexQ].separatorType = newType;
		setQtns(updatedQtns);
	};
	
	const processLearningPoint = async (indexQ) => {
		const updatedQtns = [...qtns];
		const currentQtn = { ...updatedQtns[indexQ] };
		const wksQcTypes = [30,38,40,42,44,46,47,48,49,50,52,53,54,55,57];

		if (wksQcTypes.includes(currentQtn.qcType)) {
			// Update answerLpIds with names
			if (currentQtn.answerLpIds?.length) {
				currentQtn.answerLpIds = await Promise.all(
					currentQtn.answerLpIds.map(async (lp) => ({
						...lp,
						name: await checkWksId(lp.id)
					}))
				);
			}

			// Update choice LpIds for applicable question types
			if ([30, 38].includes(currentQtn.qcType)) {
				for (const key of ['choice1LpIds', 'choice2LpIds', 'choice3LpIds']) {
					if (currentQtn[key]?.length) {
						currentQtn[key] = await Promise.all(
							currentQtn[key].map(async (lp) => ({
								...lp,
								name: await checkWksId(lp.id)
							}))
						);
					}
				}
			}
		}

		updatedQtns[indexQ] = currentQtn;
		setQtns(updatedQtns);
	};
	
	const processMCChoiceChange = (indexQ, str, field, fieldIds) => {
		const updatedQtns = [...qtns];
		if (str) {
			const [idsStr, ...rest] = str.split('|');
			updatedQtns[indexQ][field] = rest.length ? removeMCPrefix(rest.join('|')) : removeMCPrefix(str);
			updatedQtns[indexQ][fieldIds] = idsStr ? idsStr.split(',').map(i => ({ id: i, name: "" })) : [];
		} else {
			updatedQtns[indexQ][field] = "";
			updatedQtns[indexQ][fieldIds] = [];
		}
		setQtns(updatedQtns);
	};
	
	const TrueFalseNG = ({ str, qcType }) => {
		const lowerStr = str.toLowerCase();
		if (lowerStr === "true" || lowerStr.charAt(0) === "t") {
			return <div className={s.trueBadge}>TRUE</div>;
		} else if ([53,54].includes(qcType) && (lowerStr === "na" || lowerStr.charAt(0) === "n")) {
			return <div className={s.ngBadge}>NG</div>;
		} else {
			return <div className={s.falseBadge}>FALSE</div>;
		}
	};

	/*
	const AnswerChoice = ({ choiceOption, qcType, label, choiceIds }) => (
		<div className={s.answerChoiceContainer}>
			<div className={s.answerChoiceRow}>
				<div className={s.answerChoiceLabel}>{label}</div>
				{!([52,53,54].includes(qcType)) ? (
					<div className={s.answerChoiceOption}><StrBrChange str={choiceOption} /></div>
				) : (
					<div className={s.answerChoiceTfContainer}>
						<TrueFalseNG str={choiceOption} qcType={qcType} />
					</div>
				)}
			</div>
			{choiceIds?.length > 0 && (
				<div className={s.answerChoiceRow}>
					<div className={s.answerChoiceVocabLabel}>{vocabLabel(qcType)}</div>
					<div>
						{choiceIds.map((lp, indexlp) => (
							<div key={indexlp} className={s.answerChoiceWeaknessItem}>
								<div>{lp.id}</div>
								{([30,38,40,42,44,46, 57].includes(qcType)) && (
									<div className={`${s.weaknessName} ${lp.name === 'Not found' ? s['weaknessName__notFound'] : ''}`}>
										{lp.name}
									</div>
								)}
							</div>
						))}
					</div>
				</div>
			)}
		</div>
	);*/
		
	if (!fetchCompleted) return <MyComponentLoading />;
	
	return (
		<div className={s.container}>
			<div className={s.headerBackground}>
				{wordId && qtns.length === 0 && (
					<div className={s.aiCreateWordContainer}>
						<RedButton isEnabled={true} clickedAction={createMCQuestionByWordId} bText={"AI create word"} />
					</div>
				)}
			
				<div className={s.buttonSectionWrapper}>
					<div className={s.buttonColumn}>
						<div className={s.questionButtn_holder}>
							<div style={{ fontWeight: "bold", width: "80px" }}>Word</div>
							<BlueButton isEnabled={true} clickedAction={() => createQtn(47)} bText={"Audio(MC)"} />
							<BlueButton isEnabled={true} clickedAction={() => createQtn(48)} bText={"Image(MC)"} />
							<BlueButton isEnabled={true} clickedAction={() => createQtn(49)} bText={"Meaning(MC)"} />
							<BlueButton isEnabled={true} clickedAction={() => createQtn(50)} bText={"MeaningHK(MC)"} />
						</div>
						
						<div className={s.questionButtn_holder}>
							<div style={{ fontWeight: "bold", width: "80px" }}>Key Read</div>
							<BlueButton isEnabled={true} clickedAction={() => createQtn(defLP === 'wks' ? 30 : 31)} bText={"MC"} />
							<BlueButton isEnabled={true} clickedAction={() => createQtn(defLP === 'wks' ? 38 : 39)} bText={"Fill-in"} />
							<BlueButton isEnabled={true} clickedAction={() => createQtn(56)} bText={"Drag-fill-in"} />
							<BlueButton isEnabled={true} clickedAction={() => createQtn(defLP === 'wks' ? 40 : 41)} bText={"dropdown"} />
							<BlueButton isEnabled={true} clickedAction={() => createQtn(46)} bText={"Open"} />
							<BlueButton isEnabled={true} clickedAction={() => createQtn(57)} bText={"Sentence Replacement"} />

							{![72,73,74,75,81,82,83,84,85,86,87,88].includes(itemType) && (
								<GreenButton isEnabled={true} clickedAction={() => setDefLP(defLP === 'wks' ? "vocab" : "wks")} bText={defLP} />
							)}
						</div>
					</div>
					
					<div className={s.buttonColumn}>
						<div className={s.questionButtn_holder}>
							<div style={{ fontWeight: "bold", width: "80px" }}>Paragraph</div>
							<BlueButton isEnabled={true} clickedAction={() => createQtn(defLP === 'wks' ? 42 : 43)} bText={"Q&A"} />
							<BlueButton isEnabled={true} clickedAction={() => createQtn(defLP === 'wks' ? 44 : 45)} bText={"Fill-in"} />
						</div>
						
						<div className={s.questionButtn_holder}>
							<div style={{ fontWeight: "bold", width: "80px" }}>True False</div>
							<BlueButton isEnabled={true} clickedAction={() => createQtn(52)} bText={"TF"} />
							<BlueButton isEnabled={true} clickedAction={() => createQtn(53)} bText={"TF(Multi-answer)"} />						
							<BlueButton isEnabled={true} clickedAction={() => createQtn(54)} bText={"TFNA"} />						
						</div>
						
						<div className={s.questionButtn_holder}>
							<div style={{ fontWeight: "bold", width: "80px" }}>Matching</div>
							<BlueButton isEnabled={true} clickedAction={() => createQtn(55)} bText={"Matching"} />			
						</div>
					</div>
				</div>
				
				<div className={s.questionButtn_holder} style={{ background: "#a2b6db" }}>
					<div style={{ fontWeight: "bold", width: "80px" }}>Seperator</div>
					<BlueButton isEnabled={true} clickedAction={() => createQtn(51)} bText={"Seperator"} />						
				</div>
			</div>
			
			{/* 添加摘要显示切换按钮 */}
			<div style={{display: 'flex', gap: '10px'}}>
				<div className={s.summaryToggleContainer}>
					<BlueButton 
						isEnabled={true} 
						clickedAction={() => {
							setGeneralStorage('showSummary', !showSummary);
							setShowSummary(!showSummary)
						}} 
						bText={showSummary ? "Hide Summary" : "Show Summary"} 
					/>
				</div>
				<div className={s.summaryToggleContainer}>
					<BlueButton 
						isEnabled={true} 
						clickedAction={callChildGenExplanationAllLogic} 
						bText={"gen explanation"} 
					/>
				</div>
				<div className={s.summaryToggleContainer}>
					<BlueButton 
						isEnabled={true} 
						clickedAction={callChildGenExplanationIncompletedLogic} 
						bText={"fill incompleted explanation"} 
					/>
				</div>
			</div>
			
			<div id="top" className={s.totalQuestionCount}>Total Question: {qtns.length}</div>
			
			<div className={s.questionNavigation}>
				Q
				{qtns.map((_, indexQ) => (
					<div key={indexQ} className={s.questionNavItem}>
						<BlueButton isEnabled={true} clickedAction={() => handleClick(`q${indexQ+1}`)} bText={indexQ+1} />	
					</div>
				))}
			</div>
			
			{qtns.map((q, indexQ) => (
				<div key={indexQ} className={s.questionCard}>
					{/* 问题摘要显示区域 - 仅在showSummary为true时显示 */}
					
					<div className={s.questionCardHeader}>
						{![35,36,37].includes(q.qcType) && (
							<div className={`${s.question_input_holder} ${s['question_input_holder__wrap']}`}>
								<div id={`q${indexQ+1}`} className={s.inputLabel}>Q{indexQ + 1}</div>
								<div>
									<RedButton isEnabled={true} clickedAction={() => deleteQtn(q.id, indexQ)} bText={"Delete"} />	
								</div>
								<div>{q.id}</div>
								
								<div className={s.inputContainer__small}>
									<Form.Select 
										className={s.qcTypeSelect}
										value={q.qcType} 
										onChange={(e) => {
											const updatedQtns = [...qtns];
											updatedQtns[indexQ].qcType = parseInt(e.target.value);
											//updatedQtns[indexQ].input = mergeFieldToInput(updatedQtns[indexQ]);
											updatedQtns[indexQ].inputStr = (mergeFieldToInput(updatedQtns[indexQ])).inputStr;
											setQtns(updatedQtns);
											qcTypeUpdate(q.id, updatedQtns[indexQ].qcType);
										}}
									>
										{Object.entries({
											30: "MC +wks", 31: "MC +vocab",
											38: "Fill-in +wks", 39: "Fill-in +vocab",
											40: "Dropdown +wks", 41: "Dropdown +vocab",
											42: "Paragraph +wks", 43: "Paragraph +vocab",
											44: "Paragraph(Fill-in) +wks", 45: "Paragraph(Fill-in) +vocab",
											46: "Open", 47: "MC audio", 48: "MC image",
											49: "MC meaning", 50: "MC meaning HK", 51: "Separator",
											52: "True false", 53: "True false(Multi)", 54: "True false NG",
											55: "Matching", 56: "Drag-fill-in", 57: "Sentence replacement"
										}).map(([value, label]) => (
											<option key={value} value={value}>{value} {label}</option>
										))}
									</Form.Select>
								</div>
								
								<div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "10px" }}>
									{![46,47,48,49,50,57].includes(q.qcType) && (
										<GreenButton 
											isEnabled={true} 
											clickedAction={() => {
												const updatedQtns = [...qtns];
												switch (q.qcType) {
													case 30: updatedQtns[indexQ].qcType = 31; break;
													case 31: updatedQtns[indexQ].qcType = 30; break;
													case 38: updatedQtns[indexQ].qcType = 39; break;
													case 39: updatedQtns[indexQ].qcType = 38; break;
													case 40: updatedQtns[indexQ].qcType = 41; break;
													case 41: updatedQtns[indexQ].qcType = 40; break;
													case 42: updatedQtns[indexQ].qcType = 43; break;
													case 43: updatedQtns[indexQ].qcType = 42; break;
													case 44: updatedQtns[indexQ].qcType = 45; break;
													case 45: updatedQtns[indexQ].qcType = 44; break;
													default: break;
												}
												setQtns(updatedQtns);
											}} 
											bText={vocabLabel(q.qcType)}
										/>
									)}
									
									{vocabLabel(q.qcType) === 'wks' && (
										<GreenButton 
											isEnabled={true} 
											clickedAction={() => processLearningPoint(indexQ)} 
											bText={"check Wks"} 
										/>
									)}
									
									{q.id && q.qcType === 51 && (
										<GreenButton 
											isEnabled={true} 
											clickedAction={() => changeSeparatorType(indexQ)} 
											bText={q.separatorType || "default"} 
										/>
									)}
									
									{[73,81,87,88].includes(itemType) && (
										<div className={s.formatTypeSectionWrapper}>
											<div className={s.formatSection}>
												<div className={s.formatTypeLabel}>Formats:</div>
												<div className={s.formatButtonsContainer}>
													{qtnFormats.map((qf, idx) => (
														<div key={idx} className={s.formatButtonItem}>
															<GreenButton 
																isEnabled={true} 
																clickedAction={() => loadCoreWks(indexQ, qf.rWksId)} 
																bText={qf.name} 
															/>
														</div>
													))}
												</div>
											</div>
											<div className={s.typeSection}>
												<div className={s.formatTypeLabel}>Types:</div>
												<div className={s.typeButtonsContainer}>
													{qtnTypes.map((qt, idx) => (
														<div key={idx} className={s.typeButtonItem}>
															<GreenButton 
																isEnabled={true} 
																clickedAction={() => loadCoreWks(indexQ, qt.rWksId)} 
																bText={qt.name} 
															/>
														</div>
													))}
												</div>
											</div>
										</div>
									)}
								</div>
							</div>
						)}
					</div>
					
					<div className={s.questionContentWrapperRow}>
						<div className={s.questionContentWrapper}>



		<div className={s.ItemInputHolder}>
			<div className={s.ItemInputSubHolder}>
				<QuestionTextArea index={indexQ} qcType={q.qcType} />
			</div>
		</div>
























							<div className={s.ItemInputHolder}>
								<div className={s.ItemInputSubHolder}>




									{/* Mark Input */}
									<div className={s.inputRow}>
										<div className={s.inputLabel}>Mark</div>
										<div className={s.inputContainer__small}>
											<input
												type="number"
												step="0.01"
												min="0" 
												value={Number(q.mark) || 1}
												className={`${s.ItemQuestionGeneralInput} ${s['ItemQuestionGeneralInput__small']}`}
												{...createInputHandler(indexQ, 'mark', (value) => {
													const finalMark = isNaN(parseFloat(value)) ? 1 : parseFloat(value);
													updateQuestionField(q.id, finalMark, 'mark', q.qcType);
												})}
												aria-label="Edit question mark"
											/>
										</div>
									</div>

									{/* Paragraph Input */}
									<div className={s.inputRow__wrap}>
										<div className={s.inputLabel}>Paragraph</div>
										<div className={s.inputContainer__small}>
											<input
												type="string"
												value={q.paragraphStr || ""}
												className={`${s.ItemQuestionGeneralInput} ${s['ItemQuestionGeneralInput__small']}`}
												placeholder="1,2,3"
												onChange={(e) => {
													const updatedQtns = [...qtns];
													updatedQtns[indexQ].paragraphStr = e.target.value;
													updatedQtns[indexQ].paragraph = e.target.value 
														? e.target.value.split(',').map(id => id.trim()) 
														: [];
													setQtns(updatedQtns);
												}}
												onBlur={(e) => {
													const value = e.target.value.trim();
													const updatedQtns = [...qtns];
													updatedQtns[indexQ].paragraphStr = value;
													updatedQtns[indexQ].paragraph = value ? value.split(',').map(id => id.trim()) : [];
													setQtns(updatedQtns);
													if (q.id) updateParagraph(q.id, updatedQtns[indexQ].paragraph);
												}}
												aria-label="Edit question paragraph"
											/>
										</div>
										<div className={s.inputHelperTextContainer}>
											{q.paragraph?.length > 0 && (
												<div className={s.paragraphTagsContainer}>
													{q.paragraph.map((p, i) => (
														<div key={i} className={s.paragraphTag}>P{p}</div>
													))}
												</div>
											)}
										</div>
									</div>

									{/* Weakness Input */}
									<div className={s.inputRow__wrap}>
										<div className={s.inputLabel}>Weakness</div>
										<div className={s.inputContainer__small}>
											<input
												type="string"
												value={q.answerLpIdsStr || ""}
												className={`${s.ItemQuestionGeneralInput} ${s['ItemQuestionGeneralInput__small']}`}
												placeholder="1,2,3"
												onChange={(e) => {
													const updatedQtns = [...qtns];
													updatedQtns[indexQ].answerLpIdsStr = e.target.value;
													updatedQtns[indexQ].answerLpIds = e.target.value
														? e.target.value.split(',').map(id => ({ id: id.trim() }))
														: [];
													setQtns(updatedQtns);
												}}
												onBlur={(e) => {
													const value = e.target.value.trim();
													const updatedQtns = [...qtns];
													updatedQtns[indexQ].answerLpIdsStr = value;
													updatedQtns[indexQ].answerLpIds = value
														? value.split(',').map(id => ({ id: id.trim() }))
														: [];
													setQtns(updatedQtns);
													if (q.id) {
														// Send array of IDs to backend
														const ids = updatedQtns[indexQ].answerLpIds.map(item => item.id);
														updateQuestionField(q.id, ids, 'answerLpIds', q.qcType);
													}
												}}
												aria-label="Edit question Learning Point"
											/>
										</div>
										<div className={s.weaknessTagsContainer}>
											{q.answerLpIds.map(item => item.name).join(', ')}
										</div>
									</div>

									{/* Separator-specific fields */}
									{q.qcType === 51 && (
										<>
											<div className={s.inputRow}>
												<div className={s.inputLabel}>Title</div>
												<div className={s.inputContainer}>
													<input
														type="string"
														value={q.title || ""}
														className={s.ItemQuestionGeneralInput}
														{...createInputHandler(indexQ, 'title')}
														aria-label="Edit question title"
													/>
												</div>
											</div>
											<div className={s.inputRow}>
												<div className={s.inputLabel}>Title HK</div>
												<div className={s.inputContainer}>
													<input
														type="string"
														value={q.titleHk || ""}
														className={s.ItemQuestionGeneralInput}
														{...createInputHandler(indexQ, 'titleHk')}
														aria-label="Edit question title HK"
													/>
												</div>
											</div>
										</>
									)}

									{/* Question fields */}
									{q.qcType === 57 ? (<>
										<div className={s.inputRow}>
											<div className={s.inputLabel}>qtn</div>
											<div className={s.inputContainer}>
												<input
													type="string" 
													value={q.question || ""}
													className={s.ItemQuestionGeneralInput}
													{...createInputHandler(indexQ, 'question')}
													aria-label="Edit question question"
												/>
											</div>
										</div>
										{showSummary && (
											<div className={s.questionSummary}>
												{q.question && <div className={s.summaryMultiline}> {q.question.replace(/\\n/g, '\n')}</div>}									
											</div>
										)}
										</>
									) : !([47, 48].includes(q.qcType)) ? (
										<>
											<div className={s.inputRow}>
												<div className={s.inputLabel}>qtn</div>
												<div className={s.inputContainer}>
													<input
														type="string" 
														value={q.question || ""}
														className={s.ItemQuestionGeneralInput}
														{...createInputHandler(indexQ, 'question')}
														aria-label="Edit question question"
													/>
												</div>
											</div>
											{showSummary && (
												<div className={s.questionSummary}>
													{q.question && <div className={s.summaryMultiline}>{q.question.replace(/\\n/g, '\n')}</div>}									
												</div>
											)}
											<div className={s.inputRow}>
												<div className={s.inputLabel}>qtn HK</div>
												<div className={s.inputContainer}>
													<input
														type="string" 
														value={q.questionHk || ""}
														className={s.ItemQuestionGeneralInput}
														{...createInputHandler(indexQ, 'questionHk')}
														aria-label="Edit question question HK"
													/>
												</div>
											</div>
											{showSummary && (
												<div className={s.questionSummary}>
													{q.questionHk && <div className={s.summaryMultiline}>{q.questionHk.replace(/\\n/g, '\n')}</div>}									
												</div>
											)}
										</>
									) : null}

									{/* Audio question display */}
									{q.qcType === 47 && (
										<div className={s.audioQuestionRow}>
											<div className={s.audioQuestionLabel}>qtn</div>
											<div className={s.audioPlayerContainer}>
												<SoundPlayer soundFile={q.question} />
											</div>
										</div>
									)}

									{/* Image question display */}
									{q.qcType === 48 && (
										<div className={s.imageQuestionRow}>
											<div className={s.imageQuestionLabel}>qtn</div>
											<div className={s.imageContainer}>
												<Image style={{ height: "100px" }} fluid src={q.question} rounded alt="Question image" />
											</div>
										</div>
									)}

									{/* Prefix input */}
									{[38,39,40,41,44,45,56].includes(q.qcType) && (<>
										<div className={s.inputRow}>
											<div className={s.inputLabel}>Prefix</div>
											<div className={s.inputContainer}>
												<input
													type="string"
													value={q.prefix || ""}
													className={s.ItemQuestionGeneralInput}
													{...createInputHandler(indexQ, 'prefix')}
													aria-label="Edit question prefix"
												/>
											</div>
										</div>
										{showSummary && (
											<div className={s.questionSummary}>
												{q.prefix && <div className={s.summaryMultiline}> {q.prefix.replace(/\\n/g, '\n')}</div>}									
											</div>
										)}
										</>
									)}

									{/* Answer input */}
									{q.qcType !== 51 && (<>
										<div className={s.inputRow__wrap}>
											<div className={s.inputLabel}>Answer</div>
											{[30,31,40,41,47,48,49,50].includes(q.qcType) && (<><span>{(q.optionsOrder && q.optionsOrder[0]) ? q.optionsOrder[0].toUpperCase() : ""}</span></>)}
											<div className={s.inputWithHelperContainer}>
												<div className={s.inputContainer}>
													<input
														type="string"
														value={q.answer || ""}
														className={s.ItemQuestionGeneralInput}
														placeholder={[52,53,54].includes(q.qcType) ? "True / False / NA" : ""}
														{...createInputHandler(indexQ, 'answer')}
														aria-label="Edit question answer"
													/>
												</div>
											</div>
											{[52,53,54].includes(q.qcType) && (
												<TrueFalseNG str={q.answer} qcType={q.qcType} />
											)}
										</div>
										{showSummary && (
											<div className={s.questionSummary}>
												{q.answer && <div className={s.summaryMultiline}> {q.answer.replace(/\\n/g, '\n')}</div>}									
											</div>
										)}
										</>
									)}

									{/* Choice inputs */}
									{[30,31,40,41,47,48,49,50].includes(q.qcType) && (
										["choice1", "choice2", "choice3"].map((choice, idx) => (
											<div key={choice} className={s.inputRow}>
												<div className={s.inputLabel}>Choice {idx + 1}</div>
												{(q.optionsOrder && q.optionsOrder[idx+1]) ? q.optionsOrder[idx+1].toUpperCase() : ""}
												<div className={s.inputWithHelperContainer}>
													<div className={s.inputContainer}>
														<input
															type="string"
															value={q[choice] || ""}
															className={s.ItemQuestionGeneralInput}
															{...createInputHandler(indexQ, choice)}
															aria-label={`Edit question ${choice}`}
														/>
													</div>
												</div>
											</div>
										))
									)}

									{/* Suffix input */}
									{[38,39,40,41,44,45,56].includes(q.qcType) && (<>
										<div className={s.inputRow}>
											<div className={s.inputLabel}>Suffix</div>
											<div className={s.inputContainer}>
												<input
													type="string"
													value={q.suffix || ""}
													className={s.ItemQuestionGeneralInput}
													{...createInputHandler(indexQ, 'suffix')}
													aria-label="Edit question suffix"
												/>
											</div>
										</div>
										{showSummary && (
											<div className={s.questionSummary}>
												{q.suffix && <div className={s.summaryMultiline}> {q.suffix.replace(/\\n/g, '\n')}</div>}									
											</div>
										)}
										</>
									)}

									{/* AI Content input */}
									{[38,39,40,41,44,45,56].includes(q.qcType) && (<>
										<div className={s.inputRow}>
											<div className={s.inputLabel__small}>AI Content</div>
											<div style={{ width: "300px", textAlign: "left" }}>
												<input
													type="string"
													value={q.aiContent || ""}
													className={s.ItemQuestionGeneralInput}
													{...createInputHandler(indexQ, 'aiContent')}
													aria-label="Edit question AI content"
												/>
											</div>
										</div>
										{showSummary && (
											<div className={s.questionSummary}>
												{q.aiContent && <div className={s.summaryMultiline}> {q.aiContent.replace(/\\n/g, '\n')}</div>}									
											</div>
										)}
										</>
									)}

									{/* AI Msg input */}
									{[46,57].includes(q.qcType) && (<>
										<div className={s.inputRow}>
											<div className={s.inputLabel}>AI Msg</div>
											<div className={s.inputContainer}>
												<input
													type="string"
													value={q.aiMsg || ""}
													className={s.ItemQuestionGeneralInput}
													{...createInputHandler(indexQ, 'aiMsg')}
													aria-label="Edit question AI Msg"
												/>
											</div>
										</div>
										{showSummary && (
											<div className={s.questionSummary}>
												{q.aiMsg && <div className={s.summaryMultiline}> {q.aiMsg.replace(/\\n/g, '\n')}</div>}									
											</div>
										)}
										</>
									)}

									{/* Modified Answer input */}
									{[42,43,44,45].includes(q.qcType) && (
										<div className={s.inputRow}>
											<div className={s.inputLabel}>Mod-Ans</div>
											<div className={s.inputContainer}>
												<input
													type="string"
													value={q.modifiedAnswer || ""}
													className={s.ItemQuestionGeneralInput}
													{...createInputHandler(indexQ, 'modifiedAnswer')}
													aria-label="Edit question Mod-Ans"
												/>
											</div>
										</div>
									)}

									{/* Option Label input (Separator) */}
									{q.qcType === 51 && (
										<div className={s.inputRow__optionLabel}>
											<div className={s.inputLabel__extraSmall}>option Label</div>
											<div className={s.inputContainer}>
												<input
													type="string"
													value={q.optionLabel || ""}
													className={s.ItemQuestionGeneralInput}
													{...createInputHandler(indexQ, 'optionLabel')}
													aria-label="Edit question Option Label"
												/>
											</div>
										</div>
									)}

									{/* Options input (Separator) */}
									{q.qcType === 51 && (
										<div className={s.inputRow__wrap}>
											<div className={s.inputLabel}>options</div>
											<div className={s.inputWithHelperContainer}>
												<div className={s.inputContainer}>
													<input
														type="string"
														value={q.optionsStr || ""}
														className={s.ItemQuestionGeneralInput}
														placeholder="aa|bb|cc"
														onChange={(e) => {
															const updatedQtns = [...qtns];
															updatedQtns[indexQ].optionsStr = e.target.value;
															updatedQtns[indexQ].options = e.target.value ? e.target.value.split('|') : [];
															setQtns(updatedQtns);
														}}
														onBlur={(e) => {
															const value = e.target.value.trim();
															const updatedQtns = [...qtns];
															updatedQtns[indexQ].optionsStr = value;
															updatedQtns[indexQ].options = value ? value.split('|') : [];
															setQtns(updatedQtns);
															if (q.id) updateOptions(q.id, updatedQtns[indexQ].options);
														}}
														aria-label="Edit question options"
													/>
												</div>
												<div className={s.inputHelperTextContainer}>
													{q.options?.length > 0 && (
														<div style={{ display: "flex", flexDirection: "column", alignItems: "start", gap: "10px" }}>
															{q.options.map((p, i) => (
																<div key={i} style={{ background: "#66224422", maxWidth: "300px", overflowWrap: "break-word" }}>
																	{p}
																</div>
															))}
														</div>
													)}
												</div>
											</div>
										</div>
									)}

									{/* Explanation inputs */}
									<div className={s.inputRow}>
										<div className={s.inputLabel}>exp</div>
										<div className={s.inputContainer}>
											<input
												type="string"
												value={q.explanation || ""}
												className={s.ItemQuestionGeneralInput}
												{...createInputHandler(indexQ, 'explanation')}
												aria-label="Edit question explanation"
											/>
										</div>
									</div>
									{showSummary && (
										<div className={s.questionSummary}>
											{q.explanation && <div className={s.summaryMultiline}> {q.explanation.replace(/\\n/g, '\n')}</div>}									
										</div>
									)}

									<div className={s.inputRow}>
										<div className={s.inputLabel}>exp HK</div>
										<div className={s.inputContainer}>
											<input
												type="string"
												value={q.explanationHk || ""}
												className={s.ItemQuestionGeneralInput}
												{...createInputHandler(indexQ, 'explanationHk')}
												aria-label="Edit question explanation HK"
											/>
										</div>
									</div>
									{showSummary && (
										<div className={s.questionSummary}>
											{q.explanationHk && <div className={s.summaryMultiline}> {q.explanationHk.replace(/\\n/g, '\n')}</div>}									
										</div>
									)}
								</div>
							{/* Translation buttons */}
							<div className={s.translationButtonsContainer}>
								<div>Translate</div>
								{q.title && (
									<GreenButton 
										isEnabled={true} 
										clickedAction={async () => {
											const updatedQtns = [...qtns];
											updatedQtns[indexQ].titleHk = await translateHk(q.title);
											setQtns(updatedQtns);
											if (q.id) updateQuestionField(q.id, updatedQtns[indexQ].titleHk, 'titleHk', q.qcType);
										}} 
										bText={"title"} 
									/>
								)}
								{q.question && (
									<GreenButton 
										isEnabled={true} 
										clickedAction={async () => {
											const updatedQtns = [...qtns];
											updatedQtns[indexQ].questionHk = await translateHk(q.question);
											setQtns(updatedQtns);
											if (q.id) updateQuestionField(q.id, updatedQtns[indexQ].questionHk, 'questionHk', q.qcType);
										}} 
										bText={"question"} 
									/>
								)}
								{q.explanation && (
									<GreenButton 
										isEnabled={true} 
										clickedAction={async () => {
											const updatedQtns = [...qtns];
											updatedQtns[indexQ].explanationHk = await translateHkEscapeWord(q.explanation);
											setQtns(updatedQtns);
											if (q.id) updateQuestionField(q.id, updatedQtns[indexQ].explanationHk, 'explanationHk', q.qcType);
										}} 
										bText={"explanation"} 
									/>
								)}
							</div>

							{/* Question image display */}
							{q.imagePath && (
								<div className={s.questionImageContainer}>
									<Image className={s.iconLarge} fluid src={q.imagePath} rounded alt="Question image" />	
								</div>
							)}
							</div>

						</div>

						{/* Question explanation component */}
						<div className={s.questionExplanationWrapper}>
							<QuestionExplanation 
								questionId={q.id} 
								itemId={itemId} 
								createOrUpdateQtn={() => createOrUpdateQtn(indexQ)}
								triggerGenExplanationAll={genExplanationAll}
								triggerGenExplanationIncompleted={genExplanationIncompleted}
							/>
						</div>

					</div>

					{/* Action buttons */}
					<div className={s.actionButtonsContainer}>
						{/* Create/update button */}
						{([30,31,35,36,37,40,41,47,48,49,50].includes(q.qcType) && q.answer && q.choice1) ||
						 ([38,39,42,43,44,45,46,52,53,54,55,56,57].includes(q.qcType) && q.answer) ||
						 (q.qcType === 51) ? (
							<GreenButton 
								isEnabled={true} 
								clickedAction={() => createOrUpdateQtn(indexQ)} 
								bText={"create or update"} 
							/>
						) : null}

						{/* Image management buttons */}
						{q.id && itemId && (
							<>
								<BlueButton 
									isEnabled={true} 
									clickedAction={() => {
										const updatedQtns = [...qtns];
										updatedQtns[indexQ].enableImageSelection = !updatedQtns[indexQ].enableImageSelection;
										setQtns(updatedQtns);
										if (updatedQtns[indexQ].enableImageSelection) getItemImages();
									}} 
									bText={"Choose Image"} 
								/>
								{q.imagePath && (
									<RedButton 
										isEnabled={true} 
										clickedAction={() => {
											const updatedQtns = [...qtns];
											updatedQtns[indexQ].imagePath = null;
											setQtns(updatedQtns);
											removeImageInQtn(q.id);
										}} 
										bText={"Remove Image"} 
									/>
								)}
							</>
						)}

						{/* Image selection pool */}
						{q.enableImageSelection && (
							<div className={s.imageSelectionPool}>
								<div className={s.imageSelectionGrid}>
									{imagesPoolData.map((ip, idx) => (
										<img 
											key={idx}
											onClick={() => updateImageToQtn(indexQ, ip)} 
											className={s.imageSelectionItem}
											src={ip} 
											alt={`Image option ${idx + 1}`}
										/>
									))}
								</div>
							</div>
						)}
					</div>
				</div>
			))}
			
			{/* Back to top button */}
			<div className={s.backToTopButtonContainer}>
				<BlueButton isEnabled={true} clickedAction={() => handleClick('top')} bText={"back to top"} />	
			</div>
		</div>
	);
}
